import * as Switch from "@radix-ui/react-switch";

export function ToggleSwitch({ checked, onCheckedChange, disabled }) {
  return (
    <Switch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className="group relative h-6 w-14 shrink-0 rounded-full px-1 text-[12px] font-semibold text-white transition-colors duration-300 data-[state=checked]:bg-[#1879EE] data-[state=unchecked]:bg-[#D9D9D9] cursor-pointer flex items-center sm:h-7 sm:w-16 sm:text-[14px]"
    >
      <span className="absolute left-1 hidden group-data-[state=checked]:inline">
        ON
      </span>
      <span className="absolute right-1 group-data-[state=checked]:hidden">
        OFF
      </span>
      <Switch.Thumb className="absolute left-0.5 h-5 w-5 rounded-full bg-white transition-transform duration-300 data-[state=checked]:translate-x-8 sm:h-6 sm:w-6 sm:data-[state=checked]:translate-x-9" />
    </Switch.Root>
  );
}
